export default [
  {
    prefix: '241.0.1.0/24',
    count: 294,
    protocol: 'ssh',
    sourceIP: [
      { ip: '241.0.1.70', port: 22, count: 10, protocol: 'ssh' },
      { ip: '241.0.1.71', port: 22, count: 0, protocol: 'ssh' },
      { ip: '241.0.1.80', port: 22, count: 1, protocol: 'ssh' },
      { ip: '241.0.1.90', port: 22, count: 41, protocol: 'ssh' },
      { ip: '241.0.1.50', port: 22, count: 45, protocol: 'ssh' },
      { ip: '241.0.1.66', port: 22, count: 46, protocol: 'ssh' },
      { ip: '241.0.1.77', port: 22, count: 9, protocol: 'ssh' },
      { ip: '241.0.1.41', port: 22, count: 15, protocol: 'ssh' },
      { ip: '241.0.1.88', port: 22, count: 37, protocol: 'ssh' },
      { ip: '241.0.1.92', port: 22, count: 50, protocol: 'ssh' },
      { ip: '241.0.1.59', port: 22, count: 0, protocol: 'ssh' },
      { ip: '241.0.1.67', port: 22, count: 40, protocol: 'ssh' }
    ]
  },
  {
    prefix: '240.0.0.0/24',
    count: 169,
    protocol: 'ip',
    sourceIP: [
      { ip: '240.0.0.70', port: 8081, count: 45, protocol: 'ip' },
      { ip: '240.0.0.71', port: 3001, count: 42, protocol: 'ip' },
      { ip: '240.0.0.80', port: 8081, count: 36, protocol: 'ip' },
      { ip: '240.0.0.90', port: 3001, count: 3, protocol: 'ip' },
      { ip: '240.0.0.50', port: 27017, count: 29, protocol: 'ip' },
      { ip: '240.0.0.66', port: 8080, count: 14, protocol: 'ip' }
    ]
  }
];
